<template lang="html">
    <div class="speak-wrapper">
        <div class="container pt-4">
            <ul class="nav">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="{'active': locale=='vi-VN' }" @click.prevent="switchTranslation('vi-VN')">Tiếng Việt
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="{'active': locale=='zh-Hant' || locale=='zh-Hans' }" @click.prevent="switchTranslation('zh-Hant')">中文版</a>
                </li>
            </ul>
            <div class="speak-content-wrapper">
                <div class="row">
                    <div class="row mb-3">
                        <div class="col-md-4">
                            <img alt="" class="w-100 p-3" src="@/assets/image/teacher-lesson-1.png">
                        </div>
                        <div class="col-md-8 d-flex-align">
                            <div>
                                <p v-html="$t('page_speaking_about.opening')"></p>
                            </div>
                        </div>
                    </div>
                    <h5 class="text-second">{{$t('page_speaking_about.app1_title')}}</h5>
                    <div class="row">
                        <div class="col-md-8 d-flex-align">
                            <div>
                                <h5>{{$t('page_speaking_about.app1_intro1')}}</h5>
                                <p>{{$t('page_speaking_about.app1_intro2')}}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3" src="@/assets/image/teacher-lesson-2.png">
                            <img v-else alt="" class="w-100 p-3" src="@/assets/image/teacher-lesson-2-vi-VN.png">
                        </div>
                    </div>

                    <div>
                        <h4 class="p-3 speak-title-1">{{$t('page_speaking_about.app1_func1')}}</h4>
                        <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3 hidden-m" src="@/assets/image/teacher-sample-1.png">
                        <img v-else alt="" class="w-100 p-3 hidden-m" src="@/assets/image/teacher-sample-1-vi-VN.png">
                        <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3 hidden-d" src="@/assets/image/teacher-sample-m-1.png">
                        <img v-else alt="" class="w-100 p-3 hidden-d" src="@/assets/image/teacher-sample-m-1-vi-VN.png">
                        <p class="ml-4">{{$t('page_speaking_about.app1_func1_intro')}}</p>
                    </div>

                    <div>
                        <h4 class="p-3 speak-title-2">{{$t('page_speaking_about.app1_func2')}}</h4>
                        <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3 hidden-m" src="@/assets/image/teacher-sample-2.png">
                        <img v-else alt="" class="w-100 p-3 hidden-m" src="@/assets/image/teacher-sample-2-vi-VN.png">
                        <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3 hidden-d" src="@/assets/image/teacher-sample-m-2.png">
                        <img v-else alt="" class="w-100 p-3 hidden-d" src="@/assets/image/teacher-sample-m-2-vi-VN.png">
                        <p class="ml-4">{{$t('page_speaking_about.app1_func2_intro')}}</p>
                    </div>

                    <div class="mb-4">
                        <h4 class="p-3 speak-title-3">{{$t('page_speaking_about.app1_func3')}}</h4>
                        <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3 hidden-m" src="@/assets/image/teacher-sample-3.png">
                        <img v-else alt="" class="w-100 p-3 hidden-m" src="@/assets/image/teacher-sample-3-vi-VN.png">
                        <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3 hidden-d" src="@/assets/image/teacher-sample-m-3.png">
                        <img v-else alt="" class="w-100 p-3 hidden-d" src="@/assets/image/teacher-sample-m-3-vi-VN.png">
                        <p class="ml-4">{{$t('page_speaking_about.app1_func3_intro')}}</p>
                    </div>

                    <div>
                        <p>{{$t('page_speaking_about.you_can_see')}}</p>
                        <div class="row">
                            <div class="col-md-6">
                                <h4 class="pb-3 speak-title-4 mb-0 pb-0">{{$t('page_speaking_about.how_we_win_title')}}</h4>
                                <div class="speak-winner-wrapper">
                                    <ul>
                                        <li>{{$t('page_speaking_about.win_feature1')}}</li>
                                        <li>{{$t('page_speaking_about.win_feature2')}}</li>
                                        <li>{{$t('page_speaking_about.win_feature3')}}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-6 mb-5">
                                <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 pr-5 pl-5" src="@/assets/image/teacher-winner.png">
                                <img v-else alt="" class="w-100 pr-5 pl-5" src="@/assets/image/teacher-winner-vi-VN.png">
                            </div>
                        </div>
                    </div>
                </div>
                <h5 class="text-second">{{$t('page_speaking_about.app2_title')}}</h5>
                <p v-html="$t('page_speaking_about.app2_intro')"></p>
                <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3 hidden-m" src="@/assets/image/teacher-sample-4.png">
                <img v-else alt="" class="w-100 p-3 hidden-m" src="@/assets/image/teacher-sample-4-vi-VN.png">
                <img v-if="locale=='zh-Hant' || locale=='zh-Hans'" alt="" class="w-100 p-3 hidden-d" src="@/assets/image/teacher-sample-m-4.png">
                <img v-else alt="" class="w-100 p-3 hidden-d" src="@/assets/image/teacher-sample-m-4-vi-VN.png">

                <h5 class="text-second">{{$t('page_speaking_about.its_our_gift')}}</h5>
                <p class="mb-2">
                    {{$t('page_speaking_about.you_can_take_action')}}
                </p>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <a href="https://bit.ly/34dZB4D" class="speak-situation-btn p-3">
                            {{$t('page_speaking_about.action1')}}
                        </a>
                    </div>
                    <div class="col-md-6 mb-3">
                        <a href="/Speaking/Index" class="speak-class-btn p-3" v-on:click="listSC">
                            {{$t('page_speaking_about.action2')}}
                        </a>
                    </div>
                </div>
                <div class="row">
                    <p>{{$t('page_speaking_about.last_one')}}</p>
                    <div class="col-md-12 d-flex-center">
                        <button class="btn btn-second mt-2"
                                v-on:click="contactUs">
                            {{$t('page_speaking_about.contact_us')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                locale: this.$i18n.locale,
            }
        },
        methods: {
            listSC: function () {
                this.$gtag.event('ListSC', {
                    'event_category': 'iyuyan',
                    'event_label': 'speaking_about-' + this.locale,
                    'value': 20
                });
            },
            contactUs: function () {
                this.$gtag.event('Contact', {
                    'event_category': 'iyuyan',
                    'event_label': 'speaking_about-' + this.locale,
                    'value': 100
                });

                window.open('https://m.me/iyuewen', '_blank');
            },
            switchTranslation: function (locale) {
                this.locale = locale;
                this.$i18n.locale = locale;

                this.$gtag.event('SwitchLang', {
                    'event_category': 'iyuyan',
                    'event_label': 'speaking_about-' + this.locale,
                    'value': 1
                });
            },
        }
    }
</script>


<style>
    .speak-wrapper {
        background-color: #F7F8FA;
        padding-bottom: 60px;
    }

    .speak-content-wrapper {
        background-color: #fff;
        border-radius: 5px;
        margin-top: 10px;
        margin-bottom: 40px;
        padding: 60px;
    }

    .speak-title-1,
    .speak-title-2,
    .speak-title-3 {
        padding-bottom: 0px!important;
    }

    @media screen and (max-width:768px) {
        .speak-content-wrapper {
            padding: 5%;
        }

        .hidden-m {
            display: none;
        }
    }

    @media screen and (min-width:768px) {
        .hidden-d {
            display: none;
        }
    }

    .nav-item .active {
        background-color: #EC5252;
        color: #fff;
        border-radius: 5px;
    }

    .speak-title-1::before {
        content: url('../../assets/image/heart-1.png');
        padding-right: 10px;
    }

    .speak-title-2::before {
        content: url('../../assets/image/heart-2.png');
        padding-right: 10px;
    }

    .speak-title-3::before {
        content: url('../../assets/image/heart-3.png');
        padding-right: 10px;
    }

    .speak-title-4::before {
        content: url('../../assets/image/heart-4.png');
        padding-right: 10px;
    }

    .speak-winner-wrapper ul {
        list-style: none;
        padding-left: 0px;
    }

    .speak-winner-wrapper li::before {
        content: "●";
        color: #FF6072;
        display: inline-block;
        width: 1em;
    }

    .speak-situation-btn,
    .speak-class-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 150px;
        border: 2px solid #456CEB;
        border-radius: 15px;
        color: #456CEB;
    }

    .speak-class-btn::before {
        padding-right: 7px;
        content: url('../../assets/image/class-icon.png');
    }

        .speak-situation-btn::before {
            padding-right: 7px;
            content: url('../../assets/image/situation-icon.png');
        }

    .speak-situation-btn:hover,
    .speak-class-btn:hover {
        background-color: #456CEB;
        color: #fff;
    }
</style>